// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1nhc2","inner":"Footer_inner__3NaE-","nextIcon":"Footer_nextIcon__3LoHG","innerLeft":"Footer_innerLeft__8vyxK"};